var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"kt_scrolltop",staticClass:"scrolltop",attrs:{"id":"kt_scrolltop"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"svg-icon"},[_c('img',{attrs:{"src":require("../../../public/media/svg/icons/Navigation/Up-2.svg")}})])
}]

export { render, staticRenderFns }